import React from "react";

interface Props {
  id: string;
  totalUnitsAmount: number;
  singleUnitAmount: number;
  item_name: string;
  quantity: number;
  thumbPath: string;
  discount: number;
  discountAmount: number;
  onPlusClick: any;
  onMinusClick: any;
}

interface State {}

class CartItem extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }
  componentDidMount(): void {}
  render() {
    return (
      <tr>
        <td>
          <div className="img-container">
            <img
              src={this.props.thumbPath}
              alt="Rounded Image"
              className="img-rounded img-responsive"
            />
          </div>
        </td>
        <td className="td-product">
          <strong>{this.props.item_name}</strong>
        </td>
        <td className="td-price">
          <small>£</small>
          <strong>{this.props.singleUnitAmount}</strong>
        </td>
        <td className="td-number td-quantity">
          {this.props.quantity}
          <div className="btn-group">
            <button
              type="button"
              className="btn btn-sm btn-border btn-round"
              onClick={this.props.onMinusClick}
              value={this.props.id}
            >
              {" "}
              -{" "}
            </button>
            <button
              type="button"
              className="btn btn-sm btn-border btn-round"
              onClick={this.props.onPlusClick}
              value={this.props.id}
            >
              {" "}
              +{" "}
            </button>
          </div>
        </td>
        <td className="td-number">
          <small>£</small>
          <strong>{this.props.totalUnitsAmount}</strong>
        </td>
      </tr>
    );
  }
}

export default CartItem;
